import { SharingMessage } from '@eversports/klimt-patterns/SharingActions'
import DefaultSharingActions from '@eversports/klimt-patterns/SharingActions/SharingActions'
import Heading from '@eversports/klimt-primitives/legacy/Heading'
import Stack from '@eversports/klimt-primitives/legacy/Stack'

import InviteFriends from '../../../../components/InviteFriends'
import { Localized } from '../../../../localization/react'

interface Props {
  sharingMessage: SharingMessage
  matchId: string
}

const SharingActionsContent = ({ sharingMessage, matchId }: Props) => {
  return (
    <Stack gap={4}>
      <InviteFriends type="match" matchId={matchId} />
      <Heading is="h4" variant="small">
        <Localized id="share-it" />
      </Heading>
      <DefaultSharingActions sharingMessage={sharingMessage} />
    </Stack>
  )
}

export default SharingActionsContent
